import React, { memo, useCallback, useEffect } from "react";

import "./style.scss";

import { ItemSize } from "../../../services/ItemSize";

import { useIsMobile } from "../../../hooks/useIsMobile";

const DicesProduct = ({ dice, className, setSize }) => {
  const { isMobile } = useIsMobile();

  const image = dice.images[dice.images.length - 1];
  const isLeatherItems = dice.mainCategory === "LeatherItems";
  const isLeatherLetter = dice.category_type === "leatherletter";
  const style = ItemSize.getItemSize(dice, isMobile);

  useEffect(() => {
    if (setSize) {
      setSize({
        height: style.height,
        maxHeightCells: !isLeatherLetter ? null : 2,
      });
    }
  }, [setSize, style, isLeatherLetter ]);

  const renderImage = useCallback(() => {
    return (
      <img
        className={`${className}`}
        style={style}
        src={dice.images[0]}
        draggable
        alt="dice"
      />
    )
  }, [dice.images, className, style]);

  const renderHoverImage = useCallback((itemClassName) => {
    return (
      <img
        style={style}
        className={itemClassName}
        src={image}
        alt="dice_hover"
      />
    )
  }, [style]);

  if (isLeatherLetter || isLeatherItems) {
    return (
      <>
        {renderHoverImage(`${className} ${isLeatherLetter? 'DiceNoTransform' : 'DiceProductHover'}`)}
        {renderImage()}
      </>
    );
  }

  return (
    <div className="DiceContainer">
      {renderHoverImage(`${className} DiceProductHover`)}
      {renderImage()}
    </div>
  );
};

export default memo(DicesProduct);
